import { useQuery } from '@tanstack/react-query';
import { NUMBER_ZERO, QUERY_KEY } from 'constants/constants';
import { getCustomerDetails } from 'store/customer/customer-view-actions';

// Custom hook to fetch and manage customer account details for hco and mco customers
export const useCustomerDetails = (selectedCustomer) => {
  const { data, isLoading } = useQuery({
    queryKey: [QUERY_KEY.CustomerDetailData, selectedCustomer?.value],
    queryFn: async () => {
      let result = await getCustomerDetails(
        selectedCustomer?.value,
        selectedCustomer?.flag
      );

      return result?.[NUMBER_ZERO] ?? {};
    },
    enabled: !!selectedCustomer?.value,
  });
  return { data, isLoading };
};
